<template>
  <div class="nav">
    <div class="infoBox">
      <img :src="yqLogo" alt class="logo" />
      <span class="title">{{ yqName }}</span>
      <ul class="nav-list">
        <li
          @click="
            changeActive('workbench', 'workbench', '000000000', '', '首页')
          "
          :class="{ active: isActive === 'workbench' }"
          v-if="permissionCodes.indexOf('000000000') !== -1"
        >
          <!--<router-link tag="div" :to="{name:'workbench'}">首页</router-link>-->
          <div class="boxLi">
            <i class="el-icon-damai-ic_shouye" style="font-size: 24px;"></i>
            <span>首页</span>
          </div>
        </li>

        <li
          v-for="item in informationList"
          @click="
            changeActive(
              item.navStr,
              item.routerName,
              item.authCode,
              '',
              item.title
            )
          "
          :class="{ active: isActive === item.navStr }"
          v-if="permissionCodes.indexOf(item.authCode) !== -1"
        >
          <div class="boxLi">
            <i
              class="el-icon-damai-ic_ziyuanzhongxin"
              style="font-size: 24px;"
            ></i>
            <span>{{ item.title }}</span>
          </div>
        </li>

        <li
          class="application-center application-center2"
          :class="{ active: isActive === 'application' }"
          @mouseenter="
            showApplicationOutBoxMask = true
            hasOperationDialog = true
          "
          @mouseleave="
            showApplicationOutBoxMask = false
            hasOperationDialog = false
          "
        >
          <div class="boxLi">
            <i
              class="el-icon-damai-ic_yingyongzhongxin"
              style="font-size: 24px;"
            ></i>
            <span style="display: flex;align-items: center;">
              {{ title }}
              <i class="el-icon-caret-top" v-if="showApplicationOutBoxMask"></i>
              <i class="el-icon-caret-bottom" v-else></i>
            </span>
          </div>
          <!--          <i class="el-icon-damai-ic_yingyongzhongxin" style="font-size: 16px;"></i>-->
          <!--          {{ title }}-->

          <div
            @mouseenter="
              showApplicationOutBoxMask = true
              hasOperationDialog = true
            "
            class="application-out-box"
            :style="{ display: hasOperationDialog ? 'block' : 'none' }"
          >
            <template
              v-if="
                operateList.length +
                  currentList.length +
                  financeList.length +
                  energyList.length <
                  13
              "
            >
              <div class="application-box application-box-all">
                <div id="appInfo">
                  <div class="appInfo-bar">
                    <div
                      v-for="item in operateList"
                      @click="
                        changeActive(
                          item.navStr,
                          item.routerName,
                          item.state,
                          item.authCode,
                          item.title
                        )
                      "
                      class="appInfo-bar-item"
                      :class="
                        permissionCodes.indexOf(item.authCode) === -1
                          ? 'not-opened'
                          : item.state === '0'
                          ? 'not-opened'
                          : item.state === '2'
                          ? 'on-trial'
                          : ''
                      "
                      :title="item.servicesTime"
                    >
                      <img
                        :src="item.pic"
                        alt=""
                        class="appInfo-bar-item-img"
                        :class="
                          permissionCodes.indexOf(item.authCode) === -1
                            ? 'img-gray'
                            : item.state === '0'
                            ? 'img-gray'
                            : ''
                        "
                      />
                      <div
                        class="appInfo-bar-line-text"
                        :class="
                          permissionCodes.indexOf(item.authCode) === -1
                            ? 'not-opened'
                            : item.state === '0'
                            ? 'not-opened'
                            : item.state === '2'
                            ? 'on-trial'
                            : ''
                        "
                      >
                        {{ item.title }}
                        <span
                          class="appInfo-bar-line-tip"
                          v-if="item.state === '2'"
                          >试用</span
                        >
                      </div>
                    </div>
                    <div
                      v-for="item in energyList"
                      @click="
                        changeActive(
                          item.navStr,
                          item.routerName,
                          item.state,
                          item.authCode,
                          item.title
                        )
                      "
                      class="appInfo-bar-item"
                      :class="
                        permissionCodes.indexOf(item.authCode) === -1
                          ? 'not-opened'
                          : item.state === '0'
                          ? 'not-opened'
                          : item.state === '2'
                          ? 'on-trial'
                          : ''
                      "
                      :title="item.servicesTime"
                    >
                      <img
                        :src="item.pic"
                        alt=""
                        class="appInfo-bar-item-img"
                        :class="
                          permissionCodes.indexOf(item.authCode) === -1
                            ? 'img-gray'
                            : item.state === '0'
                            ? 'img-gray'
                            : ''
                        "
                      />
                      <div
                        class="appInfo-bar-line-text"
                        :class="
                          permissionCodes.indexOf(item.authCode) === -1
                            ? 'not-opened'
                            : item.state === '0'
                            ? 'not-opened'
                            : item.state === '2'
                            ? 'on-trial'
                            : ''
                        "
                      >
                        {{ item.title }}
                        <span
                          class="appInfo-bar-line-tip"
                          v-if="item.state === '2'"
                          >试用</span
                        >
                      </div>
                    </div>
                    <div
                      v-for="item in financeList"
                      @click="
                        changeActive(
                          item.navStr,
                          item.routerName,
                          item.state,
                          item.authCode,
                          item.title
                        )
                      "
                      class="appInfo-bar-item"
                      :class="
                        permissionCodes.indexOf(item.authCode) === -1
                          ? 'not-opened'
                          : item.state === '0'
                          ? 'not-opened'
                          : item.state === '2'
                          ? 'on-trial'
                          : ''
                      "
                      :title="item.servicesTime"
                    >
                      <img
                        :src="item.pic"
                        alt=""
                        class="appInfo-bar-item-img"
                        :class="
                          permissionCodes.indexOf(item.authCode) === -1
                            ? 'img-gray'
                            : item.state === '0'
                            ? 'img-gray'
                            : ''
                        "
                      />
                      <div
                        class="appInfo-bar-line-text"
                        :class="
                          permissionCodes.indexOf(item.authCode) === -1
                            ? 'not-opened'
                            : item.state === '0'
                            ? 'not-opened'
                            : item.state === '2'
                            ? 'on-trial'
                            : ''
                        "
                      >
                        {{ item.title }}
                        <span
                          class="appInfo-bar-line-tip"
                          v-if="item.state === '2'"
                          >试用</span
                        >
                      </div>
                    </div>
                    <div
                      v-for="item in currentList"
                      @click="
                        changeActive(
                          item.navStr,
                          item.routerName,
                          item.state,
                          item.authCode,
                          item.title
                        )
                      "
                      class="appInfo-bar-item"
                      :class="
                        permissionCodes.indexOf(item.authCode) === -1 &&
                        item.authCode !== '099'
                          ? 'not-opened'
                          : item.state === '0'
                          ? 'not-opened'
                          : item.state === '2'
                          ? 'on-trial'
                          : ''
                      "
                      :title="item.servicesTime"
                    >
                      <img
                        :src="item.pic"
                        alt=""
                        class="appInfo-bar-item-img"
                        :class="
                          permissionCodes.indexOf(item.authCode) === -1 &&
                          item.authCode !== '099'
                            ? 'img-gray'
                            : item.state === '0'
                            ? 'img-gray'
                            : ''
                        "
                      />
                      <div
                        class="appInfo-bar-line-text"
                        :class="
                          permissionCodes.indexOf(item.authCode) === -1 &&
                          item.authCode !== '099'
                            ? 'not-opened'
                            : item.state === '0'
                            ? 'not-opened'
                            : item.state === '2'
                            ? 'on-trial'
                            : ''
                        "
                      >
                        {{ item.title }}
                        <span
                          class="appInfo-bar-line-tip"
                          v-if="item.state === '2'"
                          >试用</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <div class="application-box" v-else>
              <div id="appInfo">
                <div class="appInfo-bar">
                  <div class="appInfo-bar-title">
                    <img
                      src="../../assets/resource_center/moudle_name_item1.png"
                      alt=""
                    />
                    <div class="appInfo-bar-title-text">新运营</div>
                    <!--                    <div class="appInfo-bar-title-decorate"></div>-->
                  </div>
                  <div
                    v-for="item in operateList"
                    @click="
                      changeActive(
                        item.navStr,
                        item.routerName,
                        item.state,
                        item.authCode,
                        item.title
                      )
                    "
                    class="appInfo-bar-item"
                    :class="
                      permissionCodes.indexOf(item.authCode) === -1
                        ? 'not-opened'
                        : item.state === '0'
                        ? 'not-opened'
                        : item.state === '2'
                        ? 'on-trial'
                        : ''
                    "
                    :title="item.servicesTime"
                  >
                    <img
                      :src="item.pic"
                      alt=""
                      class="appInfo-bar-item-img"
                      :class="
                        permissionCodes.indexOf(item.authCode) === -1
                          ? 'img-gray'
                          : item.state === '0'
                          ? 'img-gray'
                          : ''
                      "
                    />
                    <div
                      class="appInfo-bar-line-text"
                      :class="
                        permissionCodes.indexOf(item.authCode) === -1
                          ? 'not-opened'
                          : item.state === '0'
                          ? 'not-opened'
                          : item.state === '2'
                          ? 'on-trial'
                          : ''
                      "
                    >
                      {{ item.title }}
                      <span
                        class="appInfo-bar-line-tip"
                        v-if="item.state === '2'"
                        >试用</span
                      >
                    </div>
                  </div>
                </div>

                <!--                <div class="appInfo-bar-division"></div>-->

                <!--                <div class="appInfo-bar">-->
                <!--                  <div class="appInfo-bar-title">-->
                <!--                    <div class="appInfo-bar-title-text">新物业</div>-->
                <!--                    <div class="appInfo-bar-title-decorate"></div>-->
                <!--                  </div>-->
                <!--                  <div v-for="item in propertyList" @click="changeActive(item.navStr, item.routerName, item.state, item.authCode)" class="appInfo-bar-item" :class="permissionCodes.indexOf(item.authCode) === -1 ? 'not-opened' : item.state === '0' ? 'not-opened' : item.state === '2' ? 'on-trial' : ''" :title="item.servicesTime">-->
                <!--                    <img :src="item.pic" alt="" class="appInfo-bar-item-img">-->
                <!--                    <div class="appInfo-bar-line-text">{{item.title}}<span class="appInfo-bar-line-tip" v-if="item.state === '2'">试用</span></div>-->
                <!--                  </div>-->
                <!--                </div>-->

                <!--                <div class="appInfo-bar-division"></div>-->

                <div class="appInfo-bar">
                  <div class="appInfo-bar-title">
                    <img
                      src="../../assets/resource_center/moudle_name_item2.png"
                      alt=""
                    />
                    <div class="appInfo-bar-title-text">新能耗</div>
                    <!--                    <div class="appInfo-bar-title-decorate"></div>-->
                  </div>
                  <div
                    v-for="item in energyList"
                    @click="
                      changeActive(
                        item.navStr,
                        item.routerName,
                        item.state,
                        item.authCode,
                        item.title
                      )
                    "
                    class="appInfo-bar-item"
                    :class="
                      permissionCodes.indexOf(item.authCode) === -1
                        ? 'not-opened'
                        : item.state === '0'
                        ? 'not-opened'
                        : item.state === '2'
                        ? 'on-trial'
                        : ''
                    "
                    :title="item.servicesTime"
                  >
                    <img
                      :src="item.pic"
                      alt=""
                      class="appInfo-bar-item-img"
                      :class="
                        permissionCodes.indexOf(item.authCode) === -1
                          ? 'img-gray'
                          : item.state === '0'
                          ? 'img-gray'
                          : ''
                      "
                    />
                    <div
                      class="appInfo-bar-line-text"
                      :class="
                        permissionCodes.indexOf(item.authCode) === -1
                          ? 'not-opened'
                          : item.state === '0'
                          ? 'not-opened'
                          : item.state === '2'
                          ? 'on-trial'
                          : ''
                      "
                    >
                      {{ item.title }}
                      <span
                        class="appInfo-bar-line-tip"
                        v-if="item.state === '2'"
                        >试用</span
                      >
                    </div>
                  </div>
                </div>

                <!--                <div class="appInfo-bar-division"></div>-->

                <div class="appInfo-bar">
                  <div class="appInfo-bar-title">
                    <img
                      src="../../assets/resource_center/moudle_name_item3.png"
                      alt=""
                    />
                    <div class="appInfo-bar-title-text">新财务</div>
                    <!--                    <div class="appInfo-bar-title-decorate"></div>-->
                  </div>
                  <div
                    v-for="item in financeList"
                    @click="
                      changeActive(
                        item.navStr,
                        item.routerName,
                        item.state,
                        item.authCode,
                        item.title
                      )
                    "
                    class="appInfo-bar-item"
                    :class="
                      permissionCodes.indexOf(item.authCode) === -1
                        ? 'not-opened'
                        : item.state === '0'
                        ? 'not-opened'
                        : item.state === '2'
                        ? 'on-trial'
                        : ''
                    "
                    :title="item.servicesTime"
                  >
                    <img
                      :src="item.pic"
                      alt=""
                      class="appInfo-bar-item-img"
                      :class="
                        permissionCodes.indexOf(item.authCode) === -1
                          ? 'img-gray'
                          : item.state === '0'
                          ? 'img-gray'
                          : ''
                      "
                    />
                    <div
                      class="appInfo-bar-line-text"
                      :class="
                        permissionCodes.indexOf(item.authCode) === -1
                          ? 'not-opened'
                          : item.state === '0'
                          ? 'not-opened'
                          : item.state === '2'
                          ? 'on-trial'
                          : ''
                      "
                    >
                      {{ item.title }}
                      <span
                        class="appInfo-bar-line-tip"
                        v-if="item.state === '2'"
                        >试用</span
                      >
                    </div>
                  </div>
                </div>

                <!--                <div class="appInfo-bar-division"></div>-->

                <div class="appInfo-bar">
                  <div class="appInfo-bar-title">
                    <img
                      src="../../assets/resource_center/moudle_name_item4.png"
                      alt=""
                    />
                    <div class="appInfo-bar-title-text">新通行</div>
                    <!--                    <div class="appInfo-bar-title-decorate"></div>-->
                  </div>
                  <div
                    v-for="item in currentList"
                    @click="
                      changeActive(
                        item.navStr,
                        item.routerName,
                        item.state,
                        item.authCode,
                        item.title
                      )
                    "
                    class="appInfo-bar-item"
                    :class="
                      permissionCodes.indexOf(item.authCode) === -1 &&
                      item.authCode !== '099'
                        ? 'not-opened'
                        : item.state === '0'
                        ? 'not-opened'
                        : item.state === '2'
                        ? 'on-trial'
                        : ''
                    "
                    :title="item.servicesTime"
                  >
                    <img
                      :src="item.pic"
                      alt=""
                      class="appInfo-bar-item-img"
                      :class="
                        permissionCodes.indexOf(item.authCode) === -1 &&
                        item.authCode !== '099'
                          ? 'img-gray'
                          : item.state === '0'
                          ? 'img-gray'
                          : ''
                      "
                    />
                    <div
                      class="appInfo-bar-line-text"
                      :class="
                        permissionCodes.indexOf(item.authCode) === -1 &&
                        item.authCode !== '099'
                          ? 'not-opened'
                          : item.state === '0'
                          ? 'not-opened'
                          : item.state === '2'
                          ? 'on-trial'
                          : ''
                      "
                    >
                      {{ item.title }}
                      <span
                        class="appInfo-bar-line-tip"
                        v-if="item.state === '2'"
                        >试用</span
                      >
                    </div>
                  </div>
                </div>

                <!--                <div class="appInfo-bar">-->
                <!--                  <h3>新<span class="underline">安</span>全-->
                <!--                    <span class="eng">SECURITY</span>-->
                <!--                  </h3>-->
                <!--                  <div v-for="item in securityList" @click="changeActive(item.navStr, item.routerName, item.state, item.authCode)" :class="permissionCodes.indexOf(item.authCode) === -1 ? 'not-opened' : item.state === '0' ? 'not-opened' : item.state === '2' ? 'on-trial' : ''" :title="item.servicesTime">-->
                <!--                    {{item.title}}-->
                <!--                    <span class="appInfo-bar-line-tip" v-if="item.state === '2'">试用</span>-->
                <!--                  </div>-->
                <!--                </div>-->

                <!--                <div class="appInfo-bar">-->
                <!--                  <h3>新<span class="underline">数</span>据-->
                <!--                    <span class="eng" style="margin-left: -1px">DATA</span>-->
                <!--                  </h3>-->
                <!--                  <div v-for="item in dataList" @click="changeActive(item.navStr, item.routerName, item.state, item.authCode)" :class="permissionCodes.indexOf(item.authCode) === -1 ? 'not-opened' : item.state === '0' ? 'not-opened' : item.state === '2' ? 'on-trial' : ''" :title="item.servicesTime">-->
                <!--                    {{item.title}}-->
                <!--                    <span class="appInfo-bar-line-tip" v-if="item.state === '2'">试用</span>-->
                <!--                  </div>-->
                <!--                </div>-->
              </div>
            </div>
          </div>
          <div
            class="application-out-box-mask"
            v-show="showApplicationOutBoxMask"
            @mouseenter="
              showApplicationOutBoxMask = false
              hasOperationDialog = false
            "
          ></div>
        </li>

        <!--        <li @click="changeActive('config')" :class="{ active: isActive === 'config' }" v-if="permissionCodes.indexOf('010001000') !== -1">-->
        <!--          <router-link tag="div" :to="{ name: 'config-basic' }">配置中心</router-link>-->
        <!--        </li>-->
      </ul>
    </div>
    <div class="userBox">
      <ul class="user-list">
        <li
          @click="
            changeActive(
              'occupancy-approval',
              'occupancy-approval',
              '002007000'
            )
          "
          :class="{ active: isActive === 'occupancy-approval' }"
          v-if="permissionCodes.indexOf('002007000') !== -1"
          style="padding:0 30px;"
        >
          <el-badge
            :value="needHandleNumber"
            class="item"
            style="padding: 0"
            v-if="needHandleNumber != 0"
          >
            <i class="iconfont el-icon-damai-ic_daiban"></i>
          </el-badge>
          <i
            class="iconfont el-icon-damai-ic_daiban"
            v-if="needHandleNumber == 0"
          ></i>
          待办
        </li>
        <li
          style="display: flex; align-items: center"
          title="使用帮助"
          v-if="yqCode === 'test' || yqCode === 'demo'"
          @click="previewStream()"
        >
          <div class="user-info">
            <i class="iconfont el-icon-damai-shiyongbangzhu1"></i>
            帮助
          </div>
        </li>
        <li style="display: flex; align-items: center">
          <div class="user-info">
            <el-popover placement="bottom" width="150" trigger="hover">
              <!-- <el-button slot="reference">hover 激活</el-button> -->
              <span slot="reference">
                <i
                  class="iconfont el-icon-damai-saoma"
                  style="margin-right: 5px"
                ></i
                >小程序码
              </span>
              <div
                class="user-box"
                style="bottom: -204px; left: 8px; width: 120px"
              >
                <canvas
                  id="codeBox"
                  style="width: 200px;height: 200px;border-radius: 10px;margin-top: 20px;"
                />
              </div>
            </el-popover>
          </div>
        </li>
        <li
          @click="changeActive('user')"
          :class="{ active: isActive === 'user' }"
          v-if="accountName"
        >
          <div class="user-info">
            {{ accountName }}
            <i class="el-icon-caret-bottom"></i>
            <div class="user-box">
              <!--              <div>-->
              <!--                <router-link tag="div" :to="{ name: 'account-detail' }">查看详情</router-link>-->
              <!--              </div>-->
              <div>
                <div @click="dialogVisible = true">修改密码</div>
              </div>
              <div>
                <div @click="loginOut">退出</div>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <el-dialog title="修改密码" :visible.sync="dialogVisible" width="35%">
      <div class="dialogLine">
        <div><b style="color: red">*</b>旧密码</div>
        <el-input type="password" v-model="password" size="small" />
      </div>
      <div class="dialogLine">
        <div><b style="color: red">*</b>新密码</div>
        <el-input type="password" v-model="newPassword" size="small" />
      </div>
      <div class="dialogLine">
        <div><b style="color: red">*</b>确认密码</div>
        <el-input type="password" v-model="newPasswordAgain" size="small" />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="changePassword">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import md5 from 'js-md5'
import QrCodeWithLogo from 'qr-code-with-logo'
import { bus, getPermissionCodes, getPersonCode } from '../../utils/bus'
import { api } from '../../view/api/User'
import { errorHandler } from '../../utils/errorHandler'
import { nError, nSuccess } from '../../utils/notice'
import { pattern } from '../../utils/regular'
import { jurisdiction } from '../../utils/jurisdiction'

export default {
  name: 'nav-menu',
  data() {
    return {
      title: '应用中心',
      permissionCodes: [],
      isActive: 'homepage',
      showApplicationOutBoxMask: false,
      yqCode: '',
      yqName: '',
      yqLogo: '',
      accountName: '',
      accountCode: '',
      needHandleNumber: 0,

      // 资源中心
      informationList: [
        {
          code: 'PE',
          module: 'basicServicesJurisdiction',
          navStr: 'resource',
          routerName: 'yq-information',
          state: '',
          authCode: '001',
          servicesTime: '',
          title: '资源中心',
        },
      ],

      // 新运营
      operateList: [
        // {
        //   code: "PK",
        //   module: "",
        //   navStr: "application",
        //   routerName: "interface-manage",
        //   state: "",
        //   authCode: "028",
        //   servicesTime: "",
        //   title: "智慧大脑",
        //   pic:require('../../assets/nav_png/zhdn.png')
        // },
        {
          code: 'PF',
          module: 'investmentLeasingJurisdiction',
          navStr: 'application',
          routerName: 'investment-over-view',
          state: '',
          authCode: '002',
          servicesTime: '',
          title: '智慧合约',
          pic: require('../../assets/nav_png/zhhy.png'),
        },
        // {
        //   code: "PM",
        //   module: "agentServiceJurisdiction",
        //   navStr: "application",
        //   routerName: "investment-manage",
        //   state: "",
        //   authCode: "017",
        //   servicesTime: "",
        //   title: "智慧招商"
        // },
        // {
        //   code: "PS",
        //   module: "activityServiceJurisdiction",
        //   navStr: "application",
        //   routerName: "activity-manage",
        //   state: "",
        //   authCode: "019",
        //   servicesTime: "",
        //   title: "智慧活动"
        // },
        {
          code: 'PQ',
          module: 'messageServiceJurisdiction',
          navStr: 'application',
          routerName: 'message-template-manage',
          state: '',
          authCode: '006',
          servicesTime: '',
          title: '智慧消息',
          pic: require('../../assets/nav_png/zhxx.png'),
        },
        // {
        //   code: "PQ",
        //   module: "messageServiceJurisdiction",
        //   navStr: "application",
        //   routerName: "contract_template",
        //   state: "",
        //   authCode: "015",
        //   servicesTime: "",
        //   title: "智慧文书",
        //   pic:require('../../assets/nav_png/zhws.png')
        // },
        {
          code: 'PP',
          module: 'documentServiceJurisdiction',
          navStr: 'application',
          routerName: 'contract-template',
          state: '',
          authCode: '015',
          servicesTime: '',
          title: '智慧文书',
          pic: require('../../assets/nav_png/zhws.png'),
        },
        {
          code: 'PL',
          module: 'repairJurisdiction',
          navStr: 'application',
          routerName: 'repair-over-view',
          state: '',
          authCode: '011',
          servicesTime: '',
          title: '智慧报修',
          pic: require('../../assets/nav_png/zhbx.png'),
        },
        {
          code: 'PY',
          module: 'keepWatchServiceJurisdiction',
          navStr: 'application',
          routerName: 'patrol-point-manage',
          state: '',
          authCode: '025',
          servicesTime: '',
          title: '智慧巡更',
          pic: require('../../assets/nav_png/zhxg.png'),
        },
        {
          code: 'PX',
          module: 'inspectionServiceJurisdiction',
          navStr: 'application',
          routerName: 'inspection-device-type-manage',
          state: '',
          authCode: '024',
          servicesTime: '',
          title: '智慧巡检',
          pic: require('../../assets/nav_png/zhxj.png'),
        },
        // {
        //   code: "KQ",
        //   module: "workAttendanceServiceJurisdiction",
        //   navStr: "application",
        //   routerName: "attendance-department-manage",
        //   state: "",
        //   authCode: "034",
        //   servicesTime: "",
        //   title: "智慧考勤",
        //   pic:require('../../assets/nav_png/zhkq.png')
        // },
      ],

      // 新物业
      // propertyList: [
      //
      // ],

      // 新能耗
      energyList: [
        {
          code: 'PD',
          module: 'electricServiceJurisdiction',
          navStr: 'application',
          routerName: 'electronic-over-view',
          state: '',
          authCode: '005',
          servicesTime: '',
          title: '智慧用电',
          pic: require('../../assets/nav_png/zhyd.png'),
        },
        {
          code: 'QA',
          module: 'waterServiceJurisdiction',
          navStr: 'application',
          routerName: 'water-over-view',
          state: '',
          authCode: '027',
          servicesTime: '',
          title: '智慧用水',
          pic: require('../../assets/nav_png/zhys.png'),
        },
        {
          code: 'QJ',
          module: 'gasServiceJurisdiction',
          navStr: 'application',
          routerName: 'gas-over-view',
          state: '',
          authCode: '046',
          servicesTime: '',
          title: '智慧燃气',
          pic: require('../../assets/nav_png/zhrq.png'),
        },
      ],

      // 新财务
      financeList: [
        {
          code: 'PJ',
          module: 'financeServiceJurisdiction',
          navStr: 'application',
          routerName: 'finance-over-view',
          state: '',
          authCode: '013',
          servicesTime: '',
          title: '智慧财务',
          pic: require('../../assets/nav_png/zhcw.png'),
        },
        {
          code: 'PO',
          module: 'paymentServiceJurisdiction',
          navStr: 'application',
          routerName: 'charge-items-management',
          state: '',
          authCode: '014',
          servicesTime: '',
          title: '智慧收费',
          pic: require('../../assets/nav_png/zhsf.png'),
        },
        {
          code: 'PN',
          module: 'invoiceServiceJurisdiction',
          navStr: 'application',
          routerName: 'invoice-over-view',
          state: '',
          authCode: '016',
          servicesTime: '',
          title: '智慧凭证',
          pic: require('../../assets/nav_png/zhpz.png'),
        },
      ],

      // 新通行
      currentList: [
        {
          code: 'PG',
          module: 'accessControlJurisdiction',
          navStr: 'application',
          routerName: 'access-over-view',
          state: '',
          authCode: '003',
          servicesTime: '',
          title: '智慧门禁',
          pic: require('../../assets/nav_png/zhmj.png'),
        },
        {
          code: 'QS',
          module: 'smartDoorLockJurisdiction',
          navStr: 'application',
          routerName: 'lock-concentrator-manage',
          state: '',
          authCode: '056',
          servicesTime: '',
          title: '智慧门锁',
          pic: require('../../assets/nav_png/icon_lock.png'),
        },
        {
          code: 'PC',
          module: 'parkingServiceJurisdiction',
          navStr: 'application',
          routerName: 'park-over-view',
          state: '',
          authCode: '004',
          servicesTime: '',
          title: '智慧停车',
          pic: require('../../assets/nav_png/zhtc.png'),
        },
        {
          code: 'PB',
          module: 'ladderControlJurisdiction',
          navStr: 'application',
          routerName: 'ladder-over-view',
          state: '',
          authCode: '009',
          servicesTime: '',
          title: '智慧梯控',
          pic: require('../../assets/nav_png/zhtk.png'),
        },
        {
          code: 'PA',
          module: 'appointmentServiceJurisdiction',
          navStr: 'application',
          routerName: 'visitor-over-view',
          state: '',
          authCode: '007',
          servicesTime: '',
          title: '智慧访客',
          pic: require('../../assets/nav_png/zhfk.png'),
        },
      ],

      // 新安全
      // securityList: [
      //   {
      //     code: "PU",
      //     module: "monitorServiceJurisdiction",
      //     navStr: "application",
      //     routerName: "video-device",
      //     state: "",
      //     authCode: "020",
      //     servicesTime: "",
      //     title: "视频中心"
      //   },
      //   {
      //     code: "PT",
      //     module: "fireControlServiceJurisdiction",
      //     navStr: "application",
      //     routerName: "fire-over-view",
      //     state: "",
      //     authCode: "021",
      //     servicesTime: "",
      //     title: "智慧消防"
      //   },
      //   {
      //     code: "PV",
      //     module: "alarmServiceJurisdiction",
      //     navStr: "application",
      //     routerName: "alarm-device-manage",
      //     state: "",
      //     authCode: "022",
      //     servicesTime: "",
      //     title: "报警中心"
      //   },
      //   {
      //     code: "PD",
      //     module: "smartDetectionJurisdiction",
      //     navStr: "application",
      //     routerName: "smart-detection-over-view",
      //     state: "",
      //     authCode: "033",
      //     servicesTime: "",
      //     title: "配电监测"
      //   },
      //   {
      //     code: "QG",
      //     module: "CustomerFlowJurisdiction",
      //     navStr: "application",
      //     routerName: "customer-flow-over-view",
      //     state: "",
      //     authCode: "043",
      //     servicesTime: "",
      //     title: "客流应用"
      //   },
      //   {
      //     code: "QH",
      //     module: "faceRecognitionJurisdiction",
      //     navStr: "application",
      //     routerName: "monitoring-point-management",
      //     state: "",
      //     authCode: "044",
      //     servicesTime: "",
      //     title: "人脸应用"
      //   },
      //   {
      //     code: "",
      //     module: "",
      //     navStr: "application",
      //     routerName: "video-alarm-over-view",
      //     state: "",
      //     authCode: "",
      //     servicesTime: "",
      //     title: "视频报警"
      //   }
      // ],

      // 新企服
      // servicesList: [
      //   {
      //     code: "PR",
      //     module: "strictSelectionServiceJurisdiction",
      //     navStr: "application",
      //     routerName: "service-over-view",
      //     state: "",
      //     authCode: "018",
      //     servicesTime: "",
      //     title: "严选服务"
      //   },
      //   {
      //     code: "PH",
      //     module: "spaceServiceJurisdiction",
      //     navStr: "application",
      //     routerName: "site-over-view",
      //     state: "",
      //     authCode: "008",
      //     servicesTime: "",
      //     title: "智慧预约"
      //   },
      //   {
      //     code: "HQ",
      //     module: "enterpriseFavourServiceJurisdiction",
      //     navStr: "application",
      //     routerName: "latest-policy-manage",
      //     state: "",
      //     authCode: "032",
      //     servicesTime: "",
      //     title: "惠企服务"
      //   }
      // ],

      // 新数据
      // dataList: [
      //   {
      //     code: "QB",
      //     module: "dataServiceParkServiceJurisdiction",
      //     navStr: "application",
      //     routerName: "data-park-basic",
      //     state: "",
      //     authCode: "029",
      //     servicesTime: "",
      //     title: "园区数据"
      //   },
      //   {
      //     code: "QC",
      //     module: "dataServiceEnterpriseServiceJurisdiction",
      //     navStr: "application",
      //     routerName: "data-enterprise",
      //     state: "",
      //     authCode: "030",
      //     servicesTime: "",
      //     title: "企业数据"
      //   },
      //   {
      //     code: "QD",
      //     module: "dataIncubateServiceJurisdiction",
      //     navStr: "application",
      //     routerName: "incubation-over-view",
      //     state: "",
      //     authCode: "031",
      //     servicesTime: "",
      //     title: "智慧孵化"
      //   },
      //   {
      //     code: "QE",
      //     module: "questionnaireServiceJurisdiction",
      //     navStr: "application",
      //     routerName: "questionnaire-template-manage",
      //     state: "",
      //     authCode: "035",
      //     servicesTime: "",
      //     title: "数据采集"
      //   },
      //   {code: 'ZQ', module: 'politicalCommunicationServiceJurisdiction', navStr: 'application', routerName: 'quarterly-data-report-manage', state: '', authCode: '042', servicesTime: '', title: '小微政通'},
      // ],

      // 纳爱斯专享
      // cnniceList: [
      //   {
      //     code: "",
      //     module: "propertyFeeJurisdiction",
      //     navStr: "application",
      //     routerName: "property-fee-management",
      //     state: "",
      //     authCode: "040",
      //     servicesTime: "",
      //     title: "物业费台账"
      //   }
      // ],

      // 达利专享
      // daliList: [
      //   {
      //     code: "",
      //     module: "groupJurisdiction",
      //     navStr: "application",
      //     routerName: "customer-master-data",
      //     state: "",
      //     authCode: "041",
      //     servicesTime: "",
      //     title: "SAP数据对接"
      //   }
      // ],

      dialogVisible: false,
      password: '',
      newPassword: '',
      newPasswordAgain: '',

      visitedRoutes: [],
      visitedTitle: '',
      hasOperationDialog: false,
    }
  },
  created() {
    this.yqCode = bus.global.yqCode
    getPermissionCodes()
    this.permissionCodes = bus.global.permissionCodes.split(',')
    this.getPermissionCorrespondingRouterName()
    let defaultNavTop = window.sessionStorage.getItem('navTop') || this.isActive
    this.changeActive(defaultNavTop)
    this.accountName = bus.global.accountName
    this.accountCode = bus.global.accountCode
    // this.getBaklogCountByAccountCode(bus.global.accountCode)
    this.getParkInfo()
    if (this.yqCode === 'testgy') {
      this.operateList = [
        {
          code: 'PF',
          module: 'investmentLeasingJurisdiction',
          navStr: 'application',
          routerName: 'investment-over-view',
          state: '',
          authCode: '002',
          servicesTime: '',
          title: '智慧合约',
          pic: require('../../assets/nav_png/zhhy.png'),
        },
        {
          code: 'PQ',
          module: 'messageServiceJurisdiction',
          navStr: 'application',
          routerName: 'message-template-manage',
          state: '',
          authCode: '006',
          servicesTime: '',
          title: '智慧消息',
          pic: require('../../assets/nav_png/zhxx.png'),
        },
        {
          code: 'PP',
          module: 'documentServiceJurisdiction',
          navStr: 'application',
          routerName: 'contract-template',
          state: '',
          authCode: '015',
          servicesTime: '',
          title: '智慧文书',
          pic: require('../../assets/nav_png/zhws.png'),
        },
        {
          code: 'PL',
          module: 'repairJurisdiction',
          navStr: 'application',
          routerName: 'repair-over-view',
          state: '',
          authCode: '011',
          servicesTime: '',
          title: '智慧报修',
          pic: require('../../assets/nav_png/zhbx.png'),
        },
        {
          code: 'PY',
          module: 'keepWatchServiceJurisdiction',
          navStr: 'application',
          routerName: 'patrol-point-manage',
          state: '',
          authCode: '025',
          servicesTime: '',
          title: '智慧巡更',
          pic: require('../../assets/nav_png/zhxg.png'),
        },
        {
          code: 'PX',
          module: 'inspectionServiceJurisdiction',
          navStr: 'application',
          routerName: 'inspection-device-type-manage',
          state: '',
          authCode: '024',
          servicesTime: '',
          title: '智慧巡检',
          pic: require('../../assets/nav_png/zhxj.png'),
        },
        {
          code: 'KQ',
          module: 'workAttendanceServiceJurisdiction',
          navStr: 'application',
          routerName: 'check-in-application',
          state: '',
          authCode: '024',
          servicesTime: '',
          title: '酒店入住',
          pic: require('../../assets/nav_png/jdrz.png'),
        },
      ]
    }
    this.getYqServerConfig()
    this.getBaklogCountByAccountCode()

    let visitedRoutes = JSON.parse(
      window.sessionStorage.getItem('visitedRoutes')
    ) || [{ path: '/workbench', title: '首页', active: 'workbench', name: '0' }]
    window.sessionStorage.setItem(
      'visitedRoutes',
      JSON.stringify(visitedRoutes)
    )
  },
  methods: {
    // 获取服务配置数据
    getYqServerConfig() {
      this.$axios
        .post(api.getYqServerConfig, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            console.log(data, 'YQ Server');
            data.map((v) => {
              let servicesTime = ''
              if (v.configStatus === '0') {
                servicesTime = '功能未开通'
              } else if (v.configStatus === '1') {
                servicesTime = `服务起始日期：${v.serviceStartTime}至${v.serviceEndTime}`
              } else if (v.configStatus === '2') {
                servicesTime = `功能试用，起始日期：${v.serviceStartTime}至${v.serviceEndTime}`
              }

              this.operateList.map((item) => {
                if (item.code === v.configValue) {
                  item.state = v.configStatus
                  item.servicesTime = servicesTime
                }
              })

              // this.propertyList.map(item => {
              //   if (item.code === v.configValue) {
              //     item.state = v.configStatus;
              //     item.servicesTime = servicesTime;
              //   }
              // });
              //
              this.energyList.map((item) => {
                if (item.code === v.configValue) {
                  item.state = v.configStatus
                  item.servicesTime = servicesTime
                }
              })
              //
              this.financeList.map((item) => {
                if (item.code === v.configValue) {
                  item.state = v.configStatus
                  item.servicesTime = servicesTime
                }
              })
              //
              this.currentList.map((item) => {
                if (item.code === v.configValue) {
                  item.state = v.configStatus
                  item.servicesTime = servicesTime
                }
              })
              //
              // this.securityList.map(item => {
              //   if (item.code === v.configValue) {
              //     item.state = v.configStatus;
              //     item.servicesTime = servicesTime;
              //   }
              // });
              //
              // this.servicesList.map(item => {
              //   if (item.code === v.configValue) {
              //     item.state = v.configStatus;
              //     item.servicesTime = servicesTime;
              //   }
              // });

              // this.dataList.map(item => {
              //   if (item.code === v.configValue) {
              //     item.state = v.configStatus;
              //     item.servicesTime = servicesTime;
              //   }
              // });
            })
            this.operateList =  this.operateList.filter((item) => (item.state !== '0' && item.state))
              // this.propertyList.map(item => {
              //   if (item.code === v.configValue) {
              //     item.state = v.configStatus;
              //     item.servicesTime = servicesTime;
              //   }
              // });
              //
              this.energyList =  this.energyList.filter((item) => (item.state !== '0' && item.state))
            this.financeList = this.financeList.filter((item) => (item.state !== '0' && item.state))
              //
              this.currentList = this.currentList.filter((item) => (item.state !== '0' && item.state))
          }
        })
        .catch(errorHandler('查询公寓服务状态失败'))
    },

    // 获取每个模块有权限的第一个路由
    getPermissionCorrespondingRouterName() {
      jurisdiction.map((module) => {
        this.informationList.map((v) => {
          if (v.authCode === module.id) {
            for (let i = 0; i < module.children.length; i++) {
              if (this.permissionCodes.indexOf(module.children[i].id) !== -1) {
                v.routerName = module.children[i].routerName
                break
              }
            }
          }
        })
        this.operateList.map((v) => {
          if (v.authCode === module.id) {
            for (let i = 0; i < module.children.length; i++) {
              if (this.permissionCodes.indexOf(module.children[i].id) !== -1) {
                v.routerName = module.children[i].routerName
                break
              }
            }
          }
        })
        // this.propertyList.map(v => {
        //   if (v.authCode === module.id) {
        //     for (let i = 0; i < module.children.length; i++) {
        //       if (this.permissionCodes.indexOf(module.children[i].id) !== -1) {
        //         v.routerName = module.children[i].routerName;
        //         break;
        //       }
        //     }
        //   }
        // });
        this.energyList.map((v) => {
          if (v.authCode === module.id) {
            for (let i = 0; i < module.children.length; i++) {
              if (this.permissionCodes.indexOf(module.children[i].id) !== -1) {
                v.routerName = module.children[i].routerName
                break
              }
            }
          }
        })
        this.financeList.map((v) => {
          if (v.authCode === module.id) {
            for (let i = 0; i < module.children.length; i++) {
              if (this.permissionCodes.indexOf(module.children[i].id) !== -1) {
                v.routerName = module.children[i].routerName
                break
              }
            }
          }
        })
        this.currentList.map((v) => {
          if (v.authCode === module.id) {
            for (let i = 0; i < module.children.length; i++) {
              if (this.permissionCodes.indexOf(module.children[i].id) !== -1) {
                v.routerName = module.children[i].routerName
                break
              }
            }
          }
        })
        // this.securityList.map(v => {
        //   if (v.authCode === module.id) {
        //     for (let i = 0; i < module.children.length; i++) {
        //       if (this.permissionCodes.indexOf(module.children[i].id) !== -1) {
        //         v.routerName = module.children[i].routerName;
        //         break;
        //       }
        //     }
        //   }
        // });
        // this.servicesList.map(v => {
        //   if (v.authCode === module.id) {
        //     for (let i = 0; i < module.children.length; i++) {
        //       if (this.permissionCodes.indexOf(module.children[i].id) !== -1) {
        //         v.routerName = module.children[i].routerName;
        //         break;
        //       }
        //     }
        //   }
        // });
        // this.dataList.map(v => {
        //   if (v.authCode === module.id) {
        //     for (let i = 0; i < module.children.length; i++) {
        //       if (this.permissionCodes.indexOf(module.children[i].id) !== -1) {
        //         v.routerName = module.children[i].routerName;
        //         break;
        //       }
        //     }
        //   }
        // });
        // this.cnniceList.map(v => {
        //   if (v.authCode === module.id) {
        //     for (let i = 0; i < module.children.length; i++) {
        //       if (this.permissionCodes.indexOf(module.children[i].id) !== -1) {
        //         v.routerName = module.children[i].routerName;
        //         break;
        //       }
        //     }
        //   }
        // });
      })
    },

    getParkInfo() {
      this.$axios
        .post(api.getYqInfo, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.yqName = data.yqName
            window.sessionStorage.setItem('yqName', data.yqName)
            bus.global.yqName = data.yqName
            if (data.yqLogo) {
              this.yqLogo = data.yqLogo
            }
            bus.global.yqName = data.yqName
            this.getCodes(data.yqAppCode)
          }
        })
        .catch(errorHandler('获取园区信息失败'))
    },
    getCodes(yqAppCode) {
      let QrContent = `https://yq.damaiiot.com/yq/smallProgram/enterApartment/?enterPark=${yqAppCode}`
      setTimeout(() => {
        QrCodeWithLogo.toCanvas({
          canvas: document.getElementById('codeBox'),
          content: QrContent,
          width: 120,
          logo: '',
        }).catch()
      }, 100)
    },
    getBaklogCountByAccountCode() {
      // this.$axios.post(`${api.getBaklogCountByAccountCode}/${code}`, {})
      //   .then(res => {
      //     if (res.data.retCode === 1) {
      //       this.needHandleNumber = res.data.data
      //     }
      //   })
      //   .catch(errorHandler('获取信息失败'))
      this.$axios
        .post(api.getCountApproveForMe, {
          approveAccountCode: bus.global.accountCode,
          approvePersonCode: getPersonCode()
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            this.needHandleNumber = res.data.data
          }
        })
        .catch(errorHandler('获取审批数据失败'))
    },
    loginOut() {
      this.$confirm('确定退出当前账号？', '提示')
        .then(() => {
          this.$axios
            .post(api.logout, {})
            .then((res) => {
              if (res.data.retCode === 1) {
                sessionStorage.clear()
                bus.global = {
                  accountCode: '',
                  accountName: '',
                  yqCode: '',
                  yqName: '',
                  token: '',
                  accountHasBuildingCode: '',
                  permissionCodes: '',
                }
                this.$router.push({
                  name: 'login',
                })
              }
            })
            .catch(errorHandler('获取账户信息失败'))
        })
        .catch(() => {
          console.log('取消退出')
        })
    },
    changeActive(str, routerName, state, authCode, title) {
      if (title) window.sessionStorage.setItem('currentRouterTitle', title)
      this.showApplicationOutBoxMask = false
      this.hasOperationDialog = false
      let baseUrl = `${window.location.host}`
      if (routerName === 'check-in-application') {
        this.$router.push({
          name: routerName,
        })
        return
      }
      if (state === '0') {
        this.$confirm(
          '暂未开通此功能，若想使用此服务请联系官方客服0571-81606226。'
        )
        return false
      } else if (
        authCode &&
        this.permissionCodes.indexOf(authCode) === -1 &&
        authCode !== '099'
      ) {
        this.$confirm('您暂无此功能权限')
        return false
      } else {
        if (routerName === 'interface-manage') {
          if (
            this.yqCode === 'test' ||
            this.yqCode === 'nicetest' ||
            this.yqCode === 'kj'
          ) {
            window.open(
              `http://${baseUrl}/upper_strata/park_display_screen_vr?y=${this.yqCode}&a=${this.accountCode}&t=${bus.global.token}`,
              '_blank'
            )
          } else {
            window.open(
              `https://${baseUrl}/upper_strata/intelligent_brain`,
              '_blank'
            )
          }
        } else {
          window.sessionStorage.setItem('navTop', str)
          this.isActive = str
          this.$router.push({
            name: routerName,
          })
        }
      }
    },

    previewStream() {
      window.open(`https://yq.damaiiot.com/yq/help/`, '_blank')
    },

    changePassword() {
      let checkPassword = pattern.password.test(this.newPassword)
      if (!this.newPassword) {
        nError('请输入密码')
        return false
      } else {
        if (!checkPassword) {
          nError('请输入8至20位无特殊字符的密码')
          return false
        }
      }
      if (this.newPassword !== this.newPasswordAgain) {
        nError('两次密码不一致')
        return false
      }
      let name = this.accountName.toLowerCase()
      let pw = this.password + name
      let newpw = this.newPassword + name
      let once = md5(pw) + name
      let newonce = md5(newpw) + name
      let pwd
      let newpwd
      for (let i = 0; i < 9; i++) {
        pwd = md5(once)
        once = pwd + name
        newpwd = md5(newonce)
        newonce = newpwd + name
      }
      this.$axios
        .post(api.changePassword, {
          code: this.accountCode,
          password: pwd,
          newPassword: newpwd,
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.password = ''
            this.newPassword = ''
            this.newPasswordAgain = ''
            this.dialogVisible = false

            this.$axios
              .post(api.logout, {})
              .then((res) => {
                if (res.data.retCode === 1) {
                  this.$router.push({
                    name: 'login',
                  })
                }
              })
              .catch(errorHandler('退出失败'))
          }
        })
        .catch(errorHandler('修改失败'))
    },
  },
  watch: {
    $route(v) {
      this.visitedRoutes =
        JSON.parse(window.sessionStorage.getItem('visitedRoutes')) || []
      console.log(this.visitedRoutes)
      let title = window.sessionStorage.getItem('currentRouterTitle')
      let currentRoute = { path: v.path, title, active: this.isActive }
      let ifExist = this.visitedRoutes.find(
        (item) => item.title === currentRoute.title
      )
      if (ifExist) {
        this.visitedRoutes.find(
          (item) => item.title === currentRoute.title
        ).path = currentRoute.path
      } else {
        this.visitedRoutes.push(currentRoute)
      }
      window.sessionStorage.setItem(
        'visitedRoutes',
        JSON.stringify(this.visitedRoutes)
      )

      let defaultNavTop =
        window.sessionStorage.getItem('navTop') || this.isActive
      this.changeActive(defaultNavTop)
    },
  },
}
</script>

<style scoped lang="less">
.nav {
  display: flex;
  justify-content: space-between;
  height: 50px;
  background-color: #104079;
  padding: 0 20px;
  position: relative;
  .infoBox {
    display: flex;
    justify-content: flex-start;
    .logo {
      width: auto;
      height: 40px;
      margin: 7px 20px 3px 20px;
      /*border-radius: 50%;*/
    }
    .title {
      display: inline-block;
      font-size: 20px;
      color: #ffffff;
      font-weight: 700;
      line-height: 50px;
      margin-right: 30px;
    }
    .nav-list {
      color: #fff;
      display: flex;
      justify-content: flex-start;
      li {
        font-size: 16px;
        //line-height: 50px;
        div {
          font-size: 16px;
          padding: 0 30px;
        }
      }
      li:hover {
        color: #ffffff;
        cursor: pointer;
        background-color: #0c356c;
      }
      .active {
        color: #ffffff;
        background-color: #0b2045;
        border-bottom: 6px solid #1362ff;
      }
      .application-center {
        .application-out-box {
          width: 100%;
          height: auto;
          min-height: 400px;
          padding: 0;
          cursor: default;
          display: none;
          z-index: 1999999999999;
          position: absolute;
          left: 0;
          top: 50px;
          background-color: #fff;
          .application-box {
            width: 100%;
            margin: 0 auto;
            padding: 0;
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }
          .application-box-all {
            .appInfo-bar {
              height: 0.7rem !important;
            }
            .appInfo-bar-line-text {
              width: 60px !important;
            }
          }
          #appTitle {
            width: 140px;
            height: 120px;

            padding: 0 20px;
            border-right: 1px solid #97a8be;

            color: #ffffff;
            text-align: center;
          }

          #appTitle i {
            font-size: 60px;
            margin-bottom: 10px;
          }

          #appInfo {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            flex-wrap: wrap;
            padding: 10px 0 20px 0;
            .appInfo-bar-division {
              width: 1550px;
              height: 1px;
              margin: 0 auto;
              padding: 0;
              background: #dee2ea;
            }
            .appInfo-bar {
              height: 95px;
              display: flex;
              justify-content: flex-start;
              flex-wrap: wrap;
              padding: 0;
              align-items: center;
              text-align: left;
              .appInfo-bar-title {
                width: 120px;
                height: 100px;
                //background: #EFF2FF;
                //border-radius: 0px 43px 43px 0px;
                //display: flex;
                //flex-direction: column;
                //justify-content: center;
                //align-items: center;
                img {
                  width: 100px;
                  height: 110px;
                }
                .appInfo-bar-title-text {
                  font-weight: 600;
                  //color: #333333;
                  font-size: 17px;
                  padding: 0;
                  z-index: 10;
                  color: #0081df;
                  font-family: YouSheBiaoTiHei, YouSheBiaoTiHei !important;
                  margin-top: -100px;
                }
                .appInfo-bar-title-decorate {
                  z-index: 5;
                  position: relative;
                  top: -8px;
                  width: 58px;
                  height: 8px;
                  padding: 0;
                  background: linear-gradient(180deg, #5072ff 0%, #9db0ff 100%);
                }
              }
              .appInfo-bar-item {
                cursor: pointer;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                .appInfo-bar-item-img {
                  width: 45px;
                  height: 45px;
                  margin-bottom: 5px;
                  transition-property: width, height;
                  transition-duration: 0.5s, 0.5s;
                }
                .img-gray {
                  -webkit-filter: grayscale(1);
                  filter: gray;
                  filter: grayscale(1);
                }
                .appInfo-bar-line-text {
                  text-align: center;
                  color: #333;
                  padding: 0;
                  width: 120px;
                  font-size: 13px;
                  transition: font-size 0.5s;
                  .appInfo-bar-line-tip {
                    background-color: #1362ff;
                    color: #fff;
                    border: 1px solid #1362ff;
                    font-size: 10px;
                    margin-left: 5px;
                    padding: 1px 2px;
                    border-radius: 3px;
                  }
                }
              }
              .appInfo-bar-item:hover {
                .appInfo-bar-item-img {
                  width: 50px;
                  height: 50px;
                }
                .img-gray {
                  -webkit-filter: grayscale(1);
                  filter: gray;
                  filter: grayscale(1);
                }
                .appInfo-bar-line-text {
                  color: #1362ff;
                  font-size: 15px;
                  font-weight: 500;
                }
              }
              /*未开通*/
              .not-opened {
                cursor: not-allowed;
                color: #9f9fa8 !important;
              }
              .not-opened:hover {
                font-size: 13px;
                color: #9f9fa8 !important;
              }

              /*试用*/
              .on-trial {
                cursor: pointer;
                color: #333;
              }
              .on-trial:hover {
                color: #1362ff;
              }
            }
          }

          #appInfo > div > a {
            width: 140px;
            text-align: center;
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            padding: 5px 15px;
            margin: 0 0 20px 0;
            position: relative;
            overflow: hidden;
          }

          #appInfo i {
            color: #ffffff;
            font-size: 36px;
            line-height: 40px;
          }

          #appInfo p {
            font-size: 12px;
            color: #ffffff;
            line-height: 25px;
          }

          #appInfo .service_tip {
            background-color: #1362ff;
            width: 100px;
            height: 15px;
            line-height: 17px;
            color: #fff;
            font-size: 12px;
            transform: rotate(35deg);
            position: absolute;
            right: -25px;
            top: 10px;
            text-align: center;
          }

          #appInfo .service_tip2 {
            background-color: #999999;
            width: 100px;
            height: 15px;
            line-height: 17px;
            color: #ffffff;
            font-size: 12px;
            transform: rotate(35deg);
            position: absolute;
            right: -25px;
            top: 10px;
            text-align: center;
          }

          #appInfo small {
            display: inline-block;
            color: #add6ff;
            font-size: 12px;
          }

          #appInfo > div > div > a:hover {
            background-color: #003a93;
          }
        }

        .application-out-box-mask {
          width: 100%;
          height: 100vh;
          min-height: 200px;
          cursor: default;
          z-index: 1999999999;
          position: fixed;
          left: 0;
          top: 50px;
          background: #000000;
          opacity: 0.3;
        }
      }
      .application-center:hover .application-out-box {
        display: block;
      }
      .application-center2 {
        padding: 0 30px;
        .application-out-box {
          width: 100%;
          height: auto;
          min-height: unset;
          padding: 0 0.18rem 0.12rem 0.18rem;
          cursor: default;
          display: none;
          z-index: 1999999999999;
          position: absolute;
          left: 0;
          top: 50px;
          //background-color: #fff;
          background-image: url('../../assets/resource_center/menu_bgc.png');
          background-repeat: no-repeat;
          background-size: 100% 100%;
          .application-box {
            width: 100%;
            margin: 0 auto;
            padding: 0;
            display: flex;
            justify-content: flex-start;
            align-items: center;
          }

          #appTitle {
            width: 140px;
            height: 120px;

            padding: 0 20px;
            border-right: 1px solid #97a8be;

            color: #ffffff;
            text-align: center;
          }

          #appTitle i {
            font-size: 60px;
            margin-bottom: 10px;
          }

          #appInfo {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            flex-wrap: wrap;
            padding: 0;
            .appInfo-bar-division {
              width: 1550px;
              height: 1px;
              margin: 0 auto;
              padding: 0;
              background: #dee2ea;
            }
            .appInfo-bar {
              height: unset;
              display: flex;
              justify-content: flex-start;
              flex-wrap: nowrap;
              padding: 0;
              align-items: center;
              text-align: left;
              margin-top: 0.06rem;
              background-color: rgba(255, 255, 255, 0.7);
              border-radius: 0.06rem;
              .appInfo-bar-title {
                width: unset;
                height: 110px;
                background: #eff2ff;
                border-radius: 0px 43px 43px 0px;
                display: unset;
                flex-direction: unset;
                justify-content: unset;
                align-items: unset;
                padding: 0;
                .appInfo-bar-title-text {
                  //color: #333333;
                  font-size: 0.1rem !important;
                  font-family: YouSheBiaoTiHei, YouSheBiaoTiHei !important;
                  font-weight: 400 !important;
                  line-height: 20px !important;
                  padding: 0;
                  z-index: 10;
                  text-align: center;
                }
                .appInfo-bar-title-decorate {
                  z-index: 5;
                  position: relative;
                  top: -8px;
                  width: 58px;
                  height: 8px;
                  padding: 0;
                  background: linear-gradient(180deg, #5072ff 0%, #9db0ff 100%);
                }
              }
              .appInfo-bar-item {
                cursor: pointer;
                display: flex;
                justify-content: center;
                flex-direction: column;
                align-items: center;
                .appInfo-bar-item-img {
                  width: 45px;
                  height: 45px;
                  margin-bottom: 5px;
                  transition-property: width, height;
                  transition-duration: 0.5s, 0.5s;
                }
                .img-gray {
                  -webkit-filter: grayscale(1);
                  filter: gray;
                  filter: grayscale(1);
                }
                .appInfo-bar-line-text {
                  text-align: center;
                  color: #333;
                  padding: 0;
                  width: 120px;
                  font-size: 13px;
                  transition: font-size 0.5s;
                  margin-top: 0.08rem;
                  .appInfo-bar-line-tip {
                    background-color: #1362ff;
                    color: #fff;
                    border: 1px solid #1362ff;
                    font-size: 10px;
                    margin-left: 5px;
                    padding: 1px 2px;
                    border-radius: 3px;
                  }
                }
                .appInfo-bar-line-text1 {
                  width: 60px;
                }
              }
              .appInfo-bar-item:hover {
                .appInfo-bar-item-img {
                  width: 50px;
                  height: 50px;
                }
                .img-gray {
                  -webkit-filter: grayscale(1);
                  filter: gray;
                  filter: grayscale(1);
                }
                .appInfo-bar-line-text {
                  color: #1362ff;
                  font-size: 15px;
                  font-weight: 500;
                }
              }
              /*未开通*/
              .not-opened {
                cursor: not-allowed;
                color: #9f9fa8 !important;
              }
              .not-opened:hover {
                font-size: 13px;
                color: #9f9fa8 !important;
              }

              /*试用*/
              .on-trial {
                cursor: pointer;
                color: #333;
              }
              .on-trial:hover {
                color: #1362ff;
              }
            }
          }

          #appInfo > div > a {
            width: 140px;
            text-align: center;
            display: flex;
            justify-content: flex-start;
            flex-direction: column;
            padding: 5px 15px;
            margin: 0 0 20px 0;
            position: relative;
            overflow: hidden;
          }

          #appInfo i {
            color: #ffffff;
            font-size: 36px;
            line-height: 40px;
          }

          #appInfo p {
            font-size: 12px;
            color: #ffffff;
            line-height: 25px;
          }

          #appInfo .service_tip {
            background-color: #1362ff;
            width: 100px;
            height: 15px;
            line-height: 17px;
            color: #fff;
            font-size: 12px;
            transform: rotate(35deg);
            position: absolute;
            right: -25px;
            top: 10px;
            text-align: center;
          }

          #appInfo .service_tip2 {
            background-color: #999999;
            width: 100px;
            height: 15px;
            line-height: 17px;
            color: #ffffff;
            font-size: 12px;
            transform: rotate(35deg);
            position: absolute;
            right: -25px;
            top: 10px;
            text-align: center;
          }

          #appInfo small {
            display: inline-block;
            color: #add6ff;
            font-size: 12px;
          }

          #appInfo > div > div > a:hover {
            background-color: #003a93;
          }
        }

        .application-out-box-mask {
          width: 100%;
          height: 100vh;
          min-height: 200px;
          cursor: default;
          z-index: 1999999999;
          position: fixed;
          left: 0;
          top: 50px;
          background: #000000;
          opacity: 0.3;
        }
      }
      .application-center2:hover .application-out-box {
        display: block;
      }
    }
  }
  .user-list {
    color: #fff;
    display: flex;
    justify-content: flex-start;
    li {
      font-size: 16px;
      line-height: 50px;
      div {
        font-size: 16px;
        padding: 0 30px;
      }
    }
    .needHandleNumber {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      color: white;
      padding: 0;
      font-size: 14px;
      line-height: 20px;
      position: absolute;
      right: 14px;
      top: 6px;
    }
    li:hover {
      color: #ffffff;
      cursor: pointer;
      background-color: #0c356c;
      .needHandleNumber {
        background-color: #ff0000;
      }
    }
    .active {
      color: #ffffff;
      background-color: #0b2045;
      // border-bottom: 6px solid #1362ff;
    }
    .user-info {
      position: relative;
      .user-box {
        width: 100%;
        position: absolute;
        bottom: -100px;
        right: 0;
        background-color: #fff;
        color: #666666;
        z-index: 1000;
        padding: 0;
        display: none;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.16);
        div {
          padding: 0;
          font-size: 14px;
          div:hover {
            background-color: #eff2ff;
            color: #1362ff;
          }
        }
      }
    }
    .user-info:hover .user-box {
      display: block;
    }
  }
}
.nav
  .infoBox
  .nav-list
  .application-center2
  .application-out-box
  #appInfo
  .appInfo-bar:first-child {
  margin-top: 0.12rem;
}
form {
  width: 80%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
  vertical-align: -webkit-baseline-middle;
}
.form-line {
  margin: 20px 0;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 120px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
}
.dialogLine {
  width: 60%;
  margin: 20px auto;
  display: flex;
  justify-content: center;
}
.dialogLine div {
  min-width: 80px;
  text-align: right;
  margin-right: 10px;
  line-height: 30px;
}
.boxLi {
  width: 160px;
  height: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.item {
  font-size: 16px;
  line-height: 28px;
  margin-right: 10px;
  // padding: 0;
  /deep/.el-badge__content.is-fixed {
    top: 6px;
    right: 8px;
    border: none;
    background-color: #fc5a5a;
  }
}
.underline {
  border-bottom: 2px solid #1362ff;
}
.eng {
  display: block;
  font-size: 18px;
  font-weight: 400;
  color: #e3e3e3;
  margin-top: -30px;
  margin-left: -17px;
  font-family: DINCond-Black;
}
.eng-property {
  display: block;
  font-size: 18px;
  font-weight: 400;
  color: #e3e3e3;
  margin-top: -30px;
  margin-left: -24px;
  font-family: DINCond-Black;
}
.eng-energy {
  display: block;
  font-size: 18px;
  font-weight: 400;
  color: #e3e3e3;
  margin-top: -30px;
  margin-left: -12px;
  font-family: DINCond-Black;
}
.eng-group {
  display: block;
  font-size: 18px;
  font-weight: 400;
  color: #e3e3e3;
  margin-top: -30px;
  margin-left: 1px;
  font-family: DINCond-Black;
}
.el-icon-damai-ic_daiban,
.el-icon-damai-shiyongbangzhu1 {
  font-size: 18px;
}
</style>

<style scoped lang="less">
.operation-list {
  //background-color: #ff0000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/NavMenu/NavMenu.vue